<template>
  <div class="loginbBody">
    <div class="loginDiv wrap">
      <div class="login-content">
        <h1 class="login-title">用户登录</h1>
        <el-form
          :model="loginForm"
          label-width="100px"
          :rules="rules"
          ref="loginForm"
        >
          <el-form-item label="名字" prop="name">
            <el-input
              style="width: 200px"
              type="text"
              v-model="loginForm.name"
              autocomplete="off"
              placeholder="请输入名字"
              size="small"
              @change="clearLoginTimer()"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              style="width: 200px"
              type="password"
              v-model="loginForm.password"
              show-password
              autocomplete="off"
              placeholder="请输入密码"
              size="small"
              @change="clearLoginTimer()"
            ></el-input>
          </el-form-item>
          <el-form-item label="请求地址" prop="requestUrl">
            <el-input
              style="width: 200px"
              type="text"
              v-model="loginForm.requestUrl"
              autocomplete="off"
              placeholder="默认为http://47.107.138.238/bsmtp/public"
              size="small"
              @change="clearLoginTimer()"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示页面">
              <el-select @change="onChange" size="small" v-model="viewname" placeholder="">
                <el-option
                  v-for="option in viewList"
                  :key="option"
                  :value="option"
                />
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="字高" prop="fontsize">
                <el-input
                  style="width: 70px"
                  type="text"
                  v-model="fontsize"
                  autocomplete="off"
                  placeholder="16"
                  size="small"
                  @change="clearLoginTimer()"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="刷新" prop="brushpcs" style="margin-left: -40px">
                <el-input
                  style="width: 70px"
                  type="text"
                  v-model="brushpcs"
                  autocomplete="off"
                  placeholder="16"
                  size="small"
                  @change="clearLoginTimer()"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="" prop="requestUrl">
            <el-checkbox v-model="loginForm.isShowPo" @change="clearLoginTimer()">显示Po</el-checkbox>
            <el-checkbox v-model="loginForm.isShowMo" @change="clearLoginTimer()">显示模号</el-checkbox>
            <el-checkbox  v-if="viewname === '车间看板'" v-model="loginForm.isDeptpart" @change="clearLoginTimer()">部门工件</el-checkbox>
            <!-- <el-checkbox v-model="loginForm.isBusy" @change="clearLoginTimer()">加速滚动</el-checkbox> -->
          <!--<el-checkbox v-model="loginForm.isPlan" @change="clearLoginTimer()">显示排程</el-checkbox> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirm" :loading="confirmLoading"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/js/config.js'
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        name: '',
        password: '',
        requestUrl: '',
        isShowPo: false,
        isShowMo: false,
        isPlan:false,
        isBusy:false,
        isDeptpart:false
      },
      errpcs: 0,
      rules: {
        name: [{ required: true, message: '请输入名字', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
      },
      confirmLoading: false,
      loginTimer: null,
      viewList:["PO排程","出货表","运营图","车间看板","加工工号"],
      viewname:"运营图",
      fontsize:16,
      brushpcs:0.5
    }
  },
  methods: {
    onChange() {
      window.localStorage.setItem('BSMviewname',this.viewname)
    },
    confirm () {
      
      //this.loginForm.requestUrl
      var urll=this.loginForm.requestUrl
      if(urll==null || urll=='')
        urll="http://47.107.138.238/bsmtp/public";

      console.log("urll="+urll);
      this.confirmLoading = true
      // console.log()
      this.axios({
        method: 'post',
        params: {
          name: this.loginForm.name,
          psw: this.loginForm.password,
          openid: ''
        },
        //url: 'http://47.107.138.238/bsmtp/public/admin.php/index/loginfun'
        url:urll+ '/admin.php/index/loginfun'
      })
        .then(Response => {
          this.confirmLoading = false
          var resl = JSON.parse(Response.data)
          // console.log("lgoinedp");
          // console.log(resl)
          var typp = typeof resl
          // console.log(typp)
          if (typp === 'string') {
            // if (resl.match('密码错误')) {
            // }
            this.errpcs++
            this.$notify.error({
              title: '错误',
              message: resl
            })
            return
          }
          var da = resl[0]
          console.log(da)

          // console.log(da.Department);
          this.compid = da.CompID
          this.dept = da.Department
          this.userpower = da.power
          this.powerstr = da.PowerStr
          this.userinfo = da
          
          // this.$cookies.set('bsmusername', this.loginForm.name, '30d')
          // this.$cookies.set('bsmpassword', this.loginForm.password, '30d')
          // this.$cookies.set('bsmcompname', da.CHAName)
          // this.$cookies.set('bsmcompid', da.CompID)
          // this.$cookies.set('bsmdept', da.Department)
          // this.$cookies.set('bsmuserpower', da.power)
          // this.$cookies.set('bsmpowerstr', da.PowerStr)
          // this.$cookies.set('bsmuserinfo', Response.data)
          // // 存入po 以及 模号 1为显示 2不显示
          // this.$cookies.set('isShowPo', this.loginForm.isShowPo ? '1' : '2')
          // this.$cookies.set('isShowMo', this.loginForm.isShowMo ? '1' : '2')

         
          // 设置url
          //this.$cookies.set('requestUrl', this.loginForm.requestUrl ? this.loginForm.requestUrl : config.defaultUrl)
          window.localStorage.setItem('requestUrl',this.loginForm.requestUrl ? this.loginForm.requestUrl : config.defaultUrl)

          window.localStorage.setItem('bsmcompid', da.CompID)
          window.localStorage.setItem('bsmusername', this.loginForm.name, '30d')
          window.localStorage.setItem('bsmpassword', this.loginForm.password, '30d')
          window.localStorage.setItem('bsmcompname', da.CHAName)
          window.localStorage.setItem('bsmcompid', da.CompID)
          window.localStorage.setItem('bsmdept', da.Department)
          window.localStorage.setItem('bsmuserpower', da.power)
          window.localStorage.setItem('bsmpowerstr', da.PowerStr)
          window.localStorage.setItem('bsmSweetDept', da.SweetDept||"")
          
          window.localStorage.setItem('bsmuserinfo', Response.data)
          // 存入po 以及 模号 1为显示 2不显示
          window.localStorage.setItem('isShowPo', this.loginForm.isShowPo ? '1' : '2')
          window.localStorage.setItem('isShowMo', this.loginForm.isShowMo ? '1' : '2')

          window.localStorage.setItem('bsmisPlan', this.loginForm.isPlan ? '1' : '2')
          window.localStorage.setItem('bsmisBusy', this.loginForm.isBusy ? '1' : '2')
          window.localStorage.setItem('bsmshowdept', this.loginForm.isDeptpart ? '1' : '2')
          //bsmshowdept
          window.localStorage.setItem('bsmisbrushpcs', this.brushpcs)
          window.localStorage.setItem('bsmisfontsize', this.fontsize)
          window.localStorage.setItem('bsmisviewname', this.viewname)
          window.localStorage.setItem('bsmisprodep',  da.ProDeP ||0)
         
          const str = da.DPSetvar;
          console.log("da.DPSetvar",da.DPSetvar)
          if (str && str.trim() !== "") {  // 更严谨的空值检查
            const items = str.split(',');
            items.forEach(item => {  // 用 forEach 代替 map，因为这里不需要返回值
              const [key, value] = item.split(':').map(part => part.trim()); // 两边都 trim()

              console.log("key,value",key,value)
              if (key && value) {  // 确保 key 和 value 存在
                window.localStorage.setItem('bsm' + key, value);
              }
            });
          }
          // this.axios.defaults.baseURL = this.loginForm.requestUrl || config.defaultUrl

          // window.localStorage.setItem(name,value)

          // console.log('dept=' + this.dept)

          // this.$router.replace('/new')
          // "运营图","加工工号","PO排程"
          if(this.viewname=="加工工号")
             this.$router.replace('/new')
          else if (this.viewname=="PO排程" || this.viewname=="")
            this.$router.replace('/propo')
          else if (this.viewname=="出货表" )
            this.$router.replace('/shipparts')
          else if (this.viewname=="运营图" )
            this.$router.replace('/companychart')
         else if (this.viewname=="车间看板" )
         {
          if(da.ProDeP=="1")
          {
                this.axios({
                  method: 'post',
                  // params: {
                  //   compid: da.CompID,
                  //   dept: da.Department,
                  //   group: da.Groups
                  // },
                  url:urll+ '/admin.php/Bigsreen/deptgetfun?compid='+ da.CompID+"&dept="+da.Department+"&group="+da.Groups
                })
                  .then(Response => {
                    var resldep = JSON.parse(Response.data)
                    var dap = resldep[0]                   
                    window.localStorage.setItem('bsmmanormac', dap.ManOrMac)
                    window.localStorage.setItem('bsmdeptchinese', dap.Chinese)
                    

                    // console.log("dap=",dap);
                    })
                    .catch(function (error) {
                      // this.confirmLoading = false
                      console.log(error)
                    })

                    this.axios({
                      method: 'post',
                      params: {
                        compid: da.CompID,
                        name: "QATecIPQCFlage",
                        group: da.Groups
                      },
                      url:urll+ '/admin.php/Bigsreen/servargetfun'
                    })
                      .then(Response => {

                        var resldep = JSON.parse(Response.data)
                        var dap = resldep[0]
                        window.localStorage.setItem('bsmQATecIPQCFlage', dap.VarVule)
                        // console.log(resldep);
                        })
                        .catch(function (error) {
                          // this.confirmLoading = false
                          console.log(error)
                        })

                    this.axios({
                      method: 'post',
                      params: {
                        compid: da.CompID,
                        dept: da.Department,
                        group: da.Groups
                      },
                      url:urll+ '/admin.php/Bigsreen/GetAttTimeFun'
                    })
                      .then(Response => {

                        var resldep = JSON.parse(Response.data)
                        var dapp = resldep["class"][0]
                        window.localStorage.setItem('bsmclasstimes', Response.data)
                        window.localStorage.setItem('bsmdayst', dapp["dayst"])
                        window.localStorage.setItem('bsmdayoff', dapp["dayoff"])
                        window.localStorage.setItem('bsmnightst', dapp["nightst"])
                        window.localStorage.setItem('bsmnightoff', dapp["nightoff"])
                        })
                        .catch(function (error) {
                          // this.confirmLoading = false
                          console.log(error)
                        })
                        this.$router.replace('/workroomdp')
             }
           }
          window.localStorage.setItem('bsmlogdate', da.logdate)    
        })
        .catch(function (error) {
          this.confirmLoading = false
          console.log(error)
        })
        this.confirmLoading = false
    },
    startfun () {     
      //this.loginForm.name = this.$cookies.get('bsmusername')
      //this.loginForm.password = this.$cookies.get('bsmpassword')
      this.loginForm.requestUrl= window.localStorage.getItem('requestUrl')
      // window.localStorage.setItem(name,value)
      // if(this.loginForm.name=='')
      {
        this.loginForm.name =window.localStorage.getItem('bsmusername')
        this.loginForm.password =window.localStorage.getItem('bsmpassword')
        this.loginForm.isShowPo =window.localStorage.getItem('isShowPo') === '1'
        this.loginForm.isShowMo = window.localStorage.getItem('isShowMo') === '1'
        this.loginForm.isDeptpart = window.localStorage.getItem('bsmshowdept') === '1'
      
      }
      this.viewname= window.localStorage.getItem('bsmisviewname')||"运营图"
      this.brushpcs= window.localStorage.getItem('bsmisbrushpcs')||0.5;
      this.fontsize= window.localStorage.getItem('bsmisfontsize')||16
      if(this.fontsize=="null")
       this.fontsize=16;
       if(this.brushpcs=="null")
       this.brushpcs=0.5;

      // console.log(this.loginForm.name);
      // 有账号密码则10s自动登录
      if (this.loginForm.name && this.loginForm.password) {
        this.loginTimer = setTimeout(() => {
          this.confirm()
        }, 10 * 1000)
      }
    },
    // 当表单有改变的时候 清空延时器
    clearLoginTimer () {
      if (!this.loginTimer) {
        return
      }
      clearTimeout(this.loginTimer)
    }
  },
  beforeDestroy () {
    clearTimeout(this.loginTimer)
  },
  created () {
    this.loginForm.isShowPo = window.localStorage.getItem('isShowPo') === '1'
    this.loginForm.isShowMo = window.localStorage.getItem('isShowMo') === '1'

    this.startfun()
  }
}
</script>

<style scoped>
.loginbBody {
  width: 100%;
  height: 100vh;
  background-image: url('~@/assets/images/login/background.a568162c.svg');
  background-size: 100% 100%;
}
.loginDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -250px;
  width: 450px;
  /* height: 330px; */
  background: rgba(0, 0, 0, 0.04);
  border-radius: 12px;
}
.login-title {
  margin: 20px 0;
  text-align: center;
}
.login-content {
  width: 400px;
  margin: 25px auto;
  /* height: 250px; */
  /* position: absolute; */
  /* top: 25px;
  left: 25px; */
}
</style>



// WEBPACK FOOTER //
// src/views/Logindp.vue